import React, { useState, useEffect } from 'react';
import { URUNLER } from './sabitler';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

function GecmisVeSablonlarPaneli({ apiUrl, gecmis, sablonlar, onSablonYukle, onSablonSil, onSablonKaydet, onKapat,
  onTaslakYukle = () => {}, aktifTaslakId = null, onYenidenBas = null }) {
  // SUNUCU TASLAKLARI (Faz 3, 2026-10-09): her cihazdan açılır; silme yok, arşive alınır.
  const [taslaklar, setTaslaklar] = useState(null);
  const [taslakHata, setTaslakHata] = useState(null);
  const [tazele, setTazele] = useState(0);
  useEffect(() => {
    const token = localStorage.getItem('yks_token');
    fetch(`${apiUrl}/api/basim-taslak`, { headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) } })
      .then(r => r.json())
      .then(d => { if (d && d.basarili) setTaslaklar(d.taslaklar || []); else setTaslakHata(d?.hata || 'okunamadı'); })
      .catch(e => setTaslakHata(e.message));
  }, [apiUrl, tazele]);
  const taslakArsivle = async (t) => {
    if (!window.confirm(`“${t.ad}” arşive alınsın mı? (silinmez, listeden kalkar)`)) return;
    const token = localStorage.getItem('yks_token');
    await fetch(`${apiUrl}/api/basim-taslak/${t.id}/arsiv`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: '{}',
    }).catch(() => {});
    setTazele(n => n + 1);
  };

  // Sunucu basım kaydı (basim_kayit audit tablosu, 2026-08-13). Yukarıdaki
  // "Son Basımlar" localStorage'tır: yalnız BU tarayıcı, yalnız BAŞARILI
  // basımlar. Audit tablosu ise sunucu tarafındadır ve REDLERİ de tutar —
  // "20 biyoloji istedim 33 matematik geldi" gibi bir vaka ancak buradan
  // geriye dönük incelenebilir. Tablo doluyordu ama panelde görüntüsü yoktu.
  const [audit, setAudit] = useState(null);
  const [auditHata, setAuditHata] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('yks_token');
    fetch(`${apiUrl}/api/boru-hatti/basim/kayitlar?limit=30`, {
      headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    })
      .then(r => r.json())
      .then(d => { if (d && d.basarili) setAudit(d.kayitlar || []); else setAuditHata(d?.hata || 'okunamadı'); })
      .catch(e => setAuditHata(e.message));
  }, [apiUrl]);

  return (
    <div className="bg-white rounded-2xl shadow-sm border-2 border-blue-200 p-4 mb-4 basim-yazdirilmaz">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-bold text-blue-700 flex items-center gap-1.5">
          📚 Geçmiş Basımlar & Şablonlar
        </h3>
        <button onClick={onKapat} className="text-blue-600 hover:text-blue-800 text-lg">×</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Geçmiş */}
        <div>
          <div className="text-[11px] font-bold text-gray-500 mb-1.5 uppercase">Son Basımlar (en yeni 10)</div>
          {gecmis.length === 0 ? (
            <div className="text-xs text-gray-400 italic py-4 text-center bg-gray-50 rounded">Henüz geçmiş yok</div>
          ) : (
            <div className="space-y-1 max-h-48 overflow-y-auto">
              {gecmis.map((g, i) => {
                const tarih = new Date(g.tarih).toLocaleString('tr-TR', {
                  day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
                });
                return (
                  <div key={i} className="flex items-center justify-between p-2 rounded bg-gray-50 text-xs">
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold truncate">{g.baslik || g.format}</div>
                      <div className="text-[10px] text-gray-500">{tarih} · {g.format} · {g.soru_sayisi} soru · {g.kaynakModu}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Şablonlar */}
        <div>
          <div className="flex items-center justify-between mb-1.5">
            <div className="text-[11px] font-bold text-gray-500 uppercase">Kaydedilmiş Şablonlar</div>
            <button onClick={onSablonKaydet}
              className="text-[10px] px-2 py-0.5 rounded bg-emerald-100 text-emerald-700 hover:bg-emerald-200 font-semibold">
              + Yeni Şablon
            </button>
          </div>
          {sablonlar.length === 0 ? (
            <div className="text-xs text-gray-400 italic py-4 text-center bg-gray-50 rounded">Henüz şablon yok</div>
          ) : (
            <div className="space-y-1 max-h-48 overflow-y-auto">
              {sablonlar.map((s, i) => {
                const tarih = new Date(s.tarih).toLocaleDateString('tr-TR');
                return (
                  <div key={i} className="flex items-center gap-1 p-2 rounded bg-emerald-50 text-xs">
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold truncate">{s.ad}</div>
                      <div className="text-[10px] text-gray-500">{tarih} · {(URUNLER[s.urun] && URUNLER[s.urun].ad) || s.aktifFormat || ''}{s.surum !== 2 && <span className="ml-1 text-amber-700" title="Eski biçim — yüklenince yeni düzene çevrilir">(eski)</span>}</div>
                    </div>
                    <button onClick={() => onSablonYukle(s)}
                      className="text-[10px] px-2 py-0.5 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700">Yükle</button>
                    <button onClick={() => { if (window.confirm('Şablon silinsin mi?')) onSablonSil(i); }}
                      className="text-[10px] px-1.5 py-0.5 rounded text-red-500 hover:bg-red-50">×</button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Sunucu taslakları (Faz 3) */}
      <div data-taslak-listesi className="mt-4 pt-3 border-t border-blue-100">
        <div className="text-[11px] font-bold text-gray-500 mb-1.5 uppercase flex items-center gap-2">
          <span>Deneme Taslakları</span>
          <span className="text-[9px] normal-case font-normal text-gray-400">sunucuda · her cihazdan açılır</span>
        </div>
        {taslakHata && <div className="text-xs text-red-500 italic py-2 text-center bg-red-50 rounded">Taslaklar okunamadı: {taslakHata}</div>}
        {!taslakHata && taslaklar === null && <div className="text-xs text-gray-400 italic py-2 text-center bg-gray-50 rounded">Yükleniyor…</div>}
        {!taslakHata && taslaklar && taslaklar.length === 0 && (
          <div className="text-xs text-gray-400 italic py-2 text-center bg-gray-50 rounded">Henüz taslak yok — Konu Testi ekranında “💾 Taslak olarak kaydet”</div>
        )}
        {!taslakHata && taslaklar && taslaklar.length > 0 && (
          <div className="space-y-1 max-h-56 overflow-y-auto">
            {taslaklar.map(t => (
              <div key={t.id} data-taslak-satir={t.id}
                className={`flex items-center gap-2 p-2 rounded text-xs ${t.id === aktifTaslakId ? 'bg-emerald-100' : 'bg-gray-50'}`}>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{t.ad}{t.id === aktifTaslakId && <span className="ml-1 text-emerald-700">(açık)</span>}</div>
                  <div className="text-[10px] text-gray-500">
                    {(t.ozet && t.ozet.soru) || 0} soru · {((t.ozet && t.ozet.dersler) || []).length} ders
                    {t.ozet && t.ozet.sinif ? ` · ${t.ozet.sinif}. sınıf` : ''} · sürüm {t.surum} ·{' '}
                    {new Date(t.guncelleme).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                    {t.guncelleyen_email ? ` · ${t.guncelleyen_email}` : ''}
                  </div>
                </div>
                <button type="button" data-taslak-yukle={t.id} onClick={() => onTaslakYukle(t.id)}
                  className="text-[10px] px-2 py-0.5 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700">Aç</button>
                <button type="button" onClick={() => taslakArsivle(t)}
                  className="text-[10px] px-1.5 py-0.5 rounded text-gray-500 hover:bg-gray-100" title="Arşive al (silinmez)">Arşivle</button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Sunucu basım kaydı (basim_kayit audit) — REDLERİ de gösterir */}
      <div className="mt-4 pt-3 border-t border-blue-100">
        <div className="text-[11px] font-bold text-gray-500 mb-1.5 uppercase flex items-center gap-2">
          <span>Sunucu Basım Kaydı</span>
          <span className="text-[9px] normal-case font-normal text-gray-400">
            tüm kullanıcılar · başarısız denemeler dahil
          </span>
        </div>
        {auditHata && (
          <div className="text-xs text-red-500 italic py-3 text-center bg-red-50 rounded">
            Kayıt okunamadı: {auditHata}
          </div>
        )}
        {!auditHata && audit === null && (
          <div className="text-xs text-gray-400 italic py-3 text-center bg-gray-50 rounded">Yükleniyor…</div>
        )}
        {!auditHata && audit && audit.length === 0 && (
          <div className="text-xs text-gray-400 italic py-3 text-center bg-gray-50 rounded">Kayıt yok</div>
        )}
        {!auditHata && audit && audit.length > 0 && (
          <div className="overflow-x-auto max-h-56 overflow-y-auto">
            <table className="w-full text-[10px]">
              <thead className="sticky top-0 bg-white">
                <tr className="text-gray-500 text-left border-b border-gray-200">
                  <th className="py-1 pr-2">Zaman</th>
                  <th className="py-1 pr-2">Tip</th>
                  <th className="py-1 pr-2">Ders</th>
                  <th className="py-1 pr-2 text-right">İstenen</th>
                  <th className="py-1 pr-2 text-right">Dönen</th>
                  <th className="py-1 pr-2 text-right">Sayfa</th>
                  <th className="py-1 pr-2">Profil</th>
                  <th className="py-1 pr-2">Sonuç</th>
                  <th className="py-1 pr-2 text-right">Süre</th>
                  {onYenidenBas && <th className="py-1 pr-2">Yeniden bas</th>}
                </tr>
              </thead>
              <tbody>
                {audit.map(k => {
                  const ok = k.sonuc === 'basarili';
                  // Ders/adet uyuşmazlığı öğretmenin bildirdiği vakanın imzasıdır;
                  // satır kırmızıya boyanmasa da sayı farkı görünür olsun.
                  const adetFarki = k.istenen_adet != null && k.donen_adet != null
                    && k.istenen_adet !== k.donen_adet;
                  return (
                    <tr key={k.id} className={`border-b border-gray-50 ${ok ? '' : 'bg-red-50'}`}>
                      <td className="py-1 pr-2 whitespace-nowrap text-gray-500">
                        {new Date(k.olusturulma_zamani).toLocaleString('tr-TR',
                          { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                      </td>
                      <td className="py-1 pr-2">{k.tip}</td>
                      <td className="py-1 pr-2 truncate max-w-[130px]" title={k.ders_kapsami}>{k.ders_kapsami || '—'}</td>
                      <td className="py-1 pr-2 text-right">{k.istenen_adet ?? '—'}</td>
                      <td className={`py-1 pr-2 text-right ${adetFarki ? 'text-orange-600 font-bold' : ''}`}>
                        {k.donen_adet ?? '—'}
                      </td>
                      <td className="py-1 pr-2 text-right">{k.sayfa_sayisi ?? '—'}</td>
                      <td className="py-1 pr-2">{k.layout_profil || '—'}</td>
                      <td className="py-1 pr-2">
                        {ok ? <span className="text-emerald-600">✓</span> : (
                          <span className="text-red-600 font-semibold" title={k.hata_mesaji || ''}>
                            {k.red_nedeni || k.sonuc}
                          </span>
                        )}
                      </td>
                      <td className="py-1 pr-2 text-right text-gray-500">
                        {k.sure_ms != null ? `${(k.sure_ms / 1000).toFixed(1)}s` : '—'}
                      </td>
                      {onYenidenBas && (
                        <td className="py-1 pr-2 whitespace-nowrap">
                          {ok && (k.public_no_listesi || []).length > 0 && (
                            <>
                              <button type="button" data-yeniden-deneme={k.id} onClick={() => onYenidenBas(k, 'deneme')}
                                title="Aynı soruları aynı sırayla Konu Testi / Genel Deneme'ye yükler (dersler ve ÖSYM testleri kendiliğinden)"
                                className="px-1.5 py-0.5 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700">📝 Deneme</button>
                              <button type="button" data-yeniden-sb={k.id} onClick={() => onYenidenBas(k, 'soru_bankasi')}
                                title="Aynı soruları Soru Bankası'na yükler (soru bankası kaydıysa aynı testlerle)"
                                className="ml-1 px-1.5 py-0.5 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700">📘 Soru bankası</button>
                            </>
                          )}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default GecmisVeSablonlarPaneli;
